import AbstractService from '@/services/abstractService'

class PhaseThreeService extends AbstractService {
  endpoint = 'projects'

  post(id, data) {
    console.log('dataaa', data)
    // define append form
    const formData = new FormData()
    for (const key in data) {
      if(data[key] != null){
        formData.append(key, data[key])
      }   else {
        formData.append(key, '')

      }
    }
    return this.http.post(`${this.endpoint}/${id}/phase3`, formData)

    // return this.http.post(`${this.endpoint}/${data.id}`, formData)
  }
}

const Service = new PhaseThreeService()

export default Service
